import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import { useGetBrandById } from "@/features/brands/shared/hooks/useGetBrandById";

const BrandOverviewLayout = lazy(() =>
  import(
    "@/features/brands/edit/components/overview/BrandOverviewLayout"
  ).then((m) => ({ default: m.BrandOverviewLayout })),
);

export const Route = createFileRoute(
  "/_auth/_app-shell/brands/$brandId/overview",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { brandId } = Route.useParams();
  const { data: brandData } = useGetBrandById(Number(brandId));

  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center py-16">
          Loading...
        </div>
      }
    >
      <BrandOverviewLayout brandData={brandData ?? null} />
    </Suspense>
  );
}
